import { render, staticRenderFns } from "./interest-setting.vue?vue&type=template&id=3aa1ced4"
import script from "./interest-setting.vue?vue&type=script&lang=ts"
export * from "./interest-setting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports